"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CollapsedCancellationPolicy = _interopRequireDefault(require("./components/CollapsedCancellationPolicy"));
var _utils = require("./assets/utils");
var _constants = require("./assets/constants");
var _styles = require("./assets/styles");
var _CancellationPolicyStage = _interopRequireDefault(require("./components/CancellationPolicyStage"));
var _userflow = require("../../constants/userflow");
var CancellationPolicy = function CancellationPolicy(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    insurancePrice = props.insurancePrice,
    _props$nowDateISO = props.nowDateISO,
    nowDateISO = _props$nowDateISO === void 0 ? new Date().toISOString() : _props$nowDateISO,
    _props$onGetInsurance = props.onGetInsuranceClick,
    onGetInsuranceClick = _props$onGetInsurance === void 0 ? function () {
      return null;
    } : _props$onGetInsurance,
    _props$insuranceSelec = props.insuranceSelected,
    insuranceSelected = _props$insuranceSelec === void 0 ? false : _props$insuranceSelec,
    isCollapsed = props.isCollapsed,
    _props$onDetailsClick = props.onDetailsClick,
    onDetailsClick = _props$onDetailsClick === void 0 ? function () {
      return null;
    } : _props$onDetailsClick,
    _props$showBackground = props.showBackground,
    showBackground = _props$showBackground === void 0 ? true : _props$showBackground,
    showPopup = props.showPopup,
    PopupComponent = props.PopupComponent,
    data = props.data,
    isHotelOnly = props.isHotelOnly;
  var _data$cancelated_at = data.cancelated_at,
    cancellationDateISO = _data$cancelated_at === void 0 ? undefined : _data$cancelated_at,
    flightDateISO = data.flight_date,
    _data$stages = data.stages,
    stages = _data$stages === void 0 ? [] : _data$stages,
    description = data.description;
  var hasDescription = Boolean(description);
  var hasInsurance = insurancePrice !== undefined;
  var gradient = (0, _utils.getFadeColors)(_constants.BASE_STAGE_COLOR, stages.length);
  var intervalledStages = (0, _utils.getIntervaledStages)(stages, flightDateISO, cancellationDateISO || nowDateISO);
  var currentStage = (0, _utils.getCurrentStage)(intervalledStages);
  var currentReturnType = currentStage === null || currentStage === void 0 ? void 0 : currentStage.return_type;
  var insuranceBtnText = (0, _utils.getInsuranceButtonText)(insurancePrice, insuranceSelected);
  var cancelled = (0, _utils.isCancelled)(cancellationDateISO);
  var UncollapsedCancellationPolicy = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hasDescription ? /*#__PURE__*/_react["default"].createElement(_styles.StyledDescription, null, description, _userflow.NBSP, "\u20BD") : null, /*#__PURE__*/_react["default"].createElement(_styles.StyledStagesWrapper, null, intervalledStages.map(function (stage, idx) {
    return /*#__PURE__*/_react["default"].createElement(_CancellationPolicyStage["default"], (0, _extends2["default"])({
      key: stage.start_date
    }, stage, {
      firstWidest: idx === 0,
      last: stages.length > 1 && idx === stages.length - 1,
      color: gradient[idx],
      progress: stage.progress,
      cancellationDateISO: cancellationDateISO,
      cancelled: cancelled,
      firstStage: idx === 0,
      isHotelOnly: isHotelOnly
    }));
  })), hasInsurance ? /*#__PURE__*/_react["default"].createElement(StyledInsuranceButton, {
    onClick: onGetInsuranceClick
  }, insuranceBtnText) : null);
  var CollapsedCancellationPolicyWithProps = /*#__PURE__*/_react["default"].createElement(_CollapsedCancellationPolicy["default"], {
    returnType: currentReturnType,
    isMobile: false,
    isHotelOnly: isHotelOnly,
    flightDateISO: flightDateISO,
    currentStageEndDateISO: currentStage === null || currentStage === void 0 ? void 0 : currentStage.interval.endDateISO,
    hasInsurance: hasInsurance,
    insurancePrice: insurancePrice,
    onGetInsuranceClick: onGetInsuranceClick,
    insuranceSelected: insuranceSelected,
    onDetailsClick: onDetailsClick,
    isCollapsed: isCollapsed,
    isSmall: !showBackground,
    showPopup: showPopup,
    PopupComponent: PopupComponent,
    cancelled: cancelled
  });
  var CancellationPolicyContent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, CollapsedCancellationPolicyWithProps, !isCollapsed && !showPopup ? UncollapsedCancellationPolicy : null);
  return showBackground ? /*#__PURE__*/_react["default"].createElement(StyledCancellationPolicy, {
    className: className
  }, CancellationPolicyContent) : CancellationPolicyContent;
};
var StyledCancellationPolicy = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicy__StyledCancellationPolicy",
  componentId: "sc-1pl3fdp-0"
})(["width:100%;display:flex;flex-direction:column;padding:8px;background-color:var(--white);border-radius:var(--border-radius);"]);
var StyledInsuranceButton = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicy__StyledInsuranceButton",
  componentId: "sc-1pl3fdp-1"
})(["border:1px solid ", ";color:", ";font-size:14px;box-sizing:border-box;border-radius:4px;padding:10px;margin-top:12px;align-self:flex-start;cursor:pointer;transition:opacity 200ms;&:hover{opacity:0.8;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blue;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.blue;
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(CancellationPolicy);